import { apiClient } from '../apiClient';
import { ApiActionResponse } from '../types';
import { PasswordInfo, UpdateProfileRequestBody } from './types';

export const updateProfile = (data: UpdateProfileRequestBody) => {
  return apiClient.request<ApiActionResponse>('PUT', `/update-profile`, data);
};

export const getPasswordInfo = () => {
  return apiClient.request<PasswordInfo>('GET', `/password-info`);
};
